'use strict';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import moment from 'moment';
import 'moment-duration-format';
import React, {Fragment} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {HOUR, MINUTE} from '../../utils';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {PeopleItem} from '../../../personnel/components/PeopleItem';

// TODO(timers): Incorporate warning isLocationExpected is true, but isLocationCaptured is false
export function BaseTimerLogItemView(props) {
  const elapsedTime = isNumber(props.end)
    ? props.end - props.start
    : new Date().getTime() - props.start;

  return (
    <div
      className={classNames('TimerLogItem', props.className, {
        'TimerLogItem_offline': props.isPreview,
      })}
    >
      <div className="TimerLogItem__content">
        {/* {props.byName} // TODO: is this an excess prop now? */}
        <div className="TimerLogItem__worker TimerLogItem__block">
          <PeopleItem
            className="TimerLogItem__worker__person"
            isSimple={true}
            model={props.by}
            nullLabel="tasks.properties.assignedTo.null.message"

            init={props.init}
          />
        </div>
        <div className="TimerLogItem__started TimerLogItem__block">
          <span className="TimerLogItem__label">
            {props.startedLabel}
          </span>
          <span>
            {BaseTimerLogItemView.formatDate(props.start)}
          </span>
        </div>
        <div className="TimerLogItem__ended TimerLogItem__block">
          <span className="TimerLogItem__label">
            {props.endedLabel}
          </span>
          <span>
            {BaseTimerLogItemView.formatDate(props.end)}
          </span>
        </div>
        <div
          className="TimerLogItem__duration TimerLogItem__block"
          title={durationTitle(elapsedTime)}
        >
          <span className="TimerLogItem__label">
            {props.durationLabel}
          </span>
          <span>
            {BaseTimerLogItemView.formatDuration(elapsedTime)}
          </span>
        </div>
        <div className="TimerLogItem__location TimerLogItem__block">
          {props.isLocationCaptured ? (
            <Fragment>
              <span className="TimerLogItem__label">
                {props.locationLabel}
              </span>
              <span className="TimerLogItem__location__content">
                {props.location}
              </span>
            </Fragment>
          ) : null}
        </div>
      </div>
    </div>
  );
}

const PLACEHOLDER = '--';
const durationOpts = {trim: false};

BaseTimerLogItemView.formatDate = memoize(date => isNumber(date) ? moment(date).format('LT') : PLACEHOLDER);

BaseTimerLogItemView.formatDuration = memoize(fmtDuration);

BaseTimerLogItemView.propTypes = {
  className: T.string,

  // time data
  /** @type {Number} Date-Time of start in milliseconds from Unix Epoc */
  start: T.number,
  /** @type {Number} Date-Time of end in milliseconds from Unix Epoc */
  end: T.number,

  // location data
  isLocationCaptured: T.bool,
  isLocationExpected: T.bool,
  /** @type {String} Location in human readable form */
  location: T.string,

  // person data TODO(timers)
  by: T.object,
  byName: T.string,

  startedLabel: T.string,
  endedLabel: T.string,
  durationLabel: T.string,
  locationLabel: T.string,
};

function durationTitle(date) {
  if (isNumber(date)) {
    if (date < MINUTE) {
      return 'Less than 1 minute';
    } else if (date < 24 * HOUR) {
      return 'hours : minutes';
    } else {
      return 'days : hours : minutes';
    }
  } else {
    return 'No duration';
  }
}

function fmtDuration(date) {
  if (isNumber(date)) {
    if (date < MINUTE) {
      return '< 1 min';
    } else if (date < 24 * HOUR) {
      return moment.duration(date).format('hh:mm', durationOpts);
    } else {
      return moment.duration(date).format('D:hh:mm');
    }
  } else {
    return null;
  }
}

export const TimerLogItemView = I18nComponent(BaseTimerLogItemView, [
  {code: 'timers.feed.started.label', prop: 'startedLabel'},
  {code: 'timers.feed.ended.label', prop: 'endedLabel'},
  {code: 'timers.feed.duration.label', prop: 'durationLabel'},
  {code: 'timers.feed.location.label', prop: 'locationLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerLogItem/TimerLogItemView.js